import VerticalBlog from "../VerticalBlog";
import styles from "../../../styles/Blog/RecentlyPostedMobile.module.css";

const RecentlyPostedMobile = ({ blogs,ref }) => {
  return (
    <div className={styles.recentlyMobileContainer}>
      <div className={styles.recentlyMobileTitleAndSortContainer}>
        <div className={styles.recentlyMobileTitle} ref={ref}>Recently Posted</div>
        <div>
          <img src="/filter-list.svg" alt="filter-icon" />
        </div>
      </div>
      <div>
        {blogs.length > 0 ? (
          blogs.map((blog, index) => <VerticalBlog key={index} data={blog} />)
        ) : (
          <p>Blogs Not Available</p>
        )}
      </div>
    </div>
  );
};

export default RecentlyPostedMobile;
